import React, { FC, useState } from 'react';
import { Loader } from 'b2b-components/theme/components/Loader';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { WithLoaderType } from './withLoader.types';

const withLoader = <
  P,
  R extends RemoteRecord<any> = RemoteRecord<any>,
  L extends Record<string, any> = Record<string, any>,
>(
    getRemoteRecords: (props: P) => R[],
    showOnRefresh = false,
    LoadingComponent: FC<L> = (Loader as unknown) as FC<L>,
    getLoadingComponentProps: (props: P) => L = (props) => ({} as L),
  ): WithLoaderType<P> => (Component) => {
    const WithLoader = (props: P) => {
      const [firstLoadFinished, setFirstLoadFinished] = useState(false);
      const remoteRecords = getRemoteRecords(props);

      if (!firstLoadFinished && !remoteRecords.some(record => !record.isLoaded)) {
        setFirstLoadFinished(true);
      }

      if (remoteRecords.some((record) => record.isLoading)) {
        if (showOnRefresh || !firstLoadFinished) {
          const loadingComponentProps = getLoadingComponentProps(props);

          return <LoadingComponent {...loadingComponentProps} />;
        }
      }

      return <Component {...props} />;
    };

    return WithLoader;
  };

export { withLoader };
